import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ClaudeDesktop } from '../claude-desktop/claude-desktop';

@Component({
  selector: 'app-copilot-studio',
  templateUrl: './copilot-studio.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './copilot-studio.css'
})

export class CopilotStudio extends ClaudeDesktop {

}